import { Col, Row } from "react-bootstrap";

import AsyncDropdown from "@/components/AsyncDropdown/AsyncDropdown";
import { PRODUCT_GROUPS } from "@/constant/constants";

const {
  sportsMasterDataApi,
  productsMasterDataApi,
  teamsMasterDataApi,
  termsMasterDataApi,
  editionsMasterDataApi,
  brandsMasterDataApi,
  competitionsMasterDataApi,
} = require("@/apis/apis");
const { LIST_PER_PAGE, LIST_MODE } = require("@/constant/Lists/listMode");
const {
  default: useModalGetOptions,
} = require("@/CustomHooks/Modal/useModalGetOptions");

const FormFields = ({
  productGroup,
  formik,
  modalState,
  showData,
  saveError,
}) => {
  const perPage = LIST_PER_PAGE;
  const queryParams = `?mode=${LIST_MODE.SELECT}&perPage=${perPage}&filter[keyword]=`;
  const sportListApi = `${sportsMasterDataApi}${queryParams}`;
  const {
    loading: sportLoading,
    defaultOptions: sportDefaultOptions,
    debouncedFetchOptions: sportFetchOptions,
    getSelectedOption: sportGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: sportListApi,
    formikValue: formik.values.sport_id,
    formikInitialValue: formik.initialValues.sport_id,
    showData: showData?.data?.sport,
  });

  const productListApi = `${productsMasterDataApi}${queryParams}`;
  const {
    loading: productLoading,
    defaultOptions: productDefaultOptions,
    debouncedFetchOptions: productFetchOptions,
    getSelectedOption: productGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: productListApi,
    formikValue: formik.values.product_id,
    formikInitialValue: formik.initialValues.product_id,
    showData: showData?.data?.product,
  });

  const teamListApi = `${teamsMasterDataApi}${queryParams}`;
  const {
    loading: teamLoading,
    defaultOptions: teamDefaultOptions,
    debouncedFetchOptions: teamFetchOptions,
    getSelectedOption: teamGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: teamListApi,
    formikValue: formik.values.team_id,
    formikInitialValue: formik.initialValues.team_id,
    showData: showData?.data?.team,
  });

  const termListApi = `${termsMasterDataApi}${queryParams}`;
  const {
    loading: termLoading,
    defaultOptions: termDefaultOptions,
    debouncedFetchOptions: termFetchOptions,
    getSelectedOption: termGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: termListApi,
    formikValue: formik.values.term_id,
    formikInitialValue: formik.initialValues.term_id,
    showData: showData?.data?.name,
  });
  const editionListApi = `${editionsMasterDataApi}${queryParams}`;
  const {
    loading: editionLoading,
    defaultOptions: editionDefaultOptions,
    debouncedFetchOptions: editionFetchOptions,
    getSelectedOption: editionGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: editionListApi,
    formikValue: formik.values.edition_id,
    formikInitialValue: formik.initialValues.edition_id,
    showData: showData?.data?.edition,
  });
  const brandListApi = `${brandsMasterDataApi}${queryParams}`;
  const {
    loading: brandLoading,
    defaultOptions: brandDefaultOptions,
    debouncedFetchOptions: brandFetchOptions,
    getSelectedOption: brandGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: brandListApi,
    formikValue: formik.values.brand_id,
    formikInitialValue: formik.initialValues.brand_id,
    showData: showData?.data?.brand,
  });
  const competitionListApi = `${competitionsMasterDataApi}${queryParams}`;
  const {
    loading: competitionLoading,
    defaultOptions: competitionDefaultOptions,
    debouncedFetchOptions: competitionFetchOptions,
    getSelectedOption: competitionGetSelectedOption,
  } = useModalGetOptions({
    modalState,
    listApi: competitionListApi,
    formikValue: formik.values.competition_id,
    formikInitialValue: formik.initialValues.competition_id,
    showData: showData?.data?.competition,
  });

  const fields = {
    [PRODUCT_GROUPS.JERSEYS]: (
      <>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Sport"
              placeholder="No sport selected. Type to search..."
              defaultOptions={sportDefaultOptions}
              loadOptions={sportFetchOptions}
              isLoading={sportLoading}
              value={sportGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("sport_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.sport_id && formik.errors.sport_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.sport_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Product"
              placeholder="No product selected. Type to search..."
              defaultOptions={productDefaultOptions}
              loadOptions={productFetchOptions}
              isLoading={productLoading}
              value={productGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("product_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.product_id && formik.errors.product_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.product_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Team"
              placeholder="No team selected. Type to search..."
              defaultOptions={teamDefaultOptions}
              loadOptions={teamFetchOptions}
              isLoading={teamLoading}
              value={teamGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("team_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.team_id && formik.errors.team_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.team_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Term"
              placeholder="No term selected. Type to search..."
              defaultOptions={termDefaultOptions}
              loadOptions={termFetchOptions}
              isLoading={termLoading}
              value={termGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("term_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.term_id && formik.errors.term_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.term_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Edition"
              placeholder="No edition selected. Type to search..."
              defaultOptions={editionDefaultOptions}
              loadOptions={editionFetchOptions}
              isLoading={editionLoading}
              value={editionGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("edition_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.edition_id && formik.errors.edition_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.edition_id?.join(" "))
              }
            />
          </Col>
        </Row>
        {/* <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Brand"
              placeholder="No brand selected. Type to search..."
              defaultOptions={brandDefaultOptions}
              loadOptions={brandFetchOptions}
              isLoading={brandLoading}
              value={brandGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("brand_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.brand_id && formik.errors.brand_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.brand_id?.join(" "))
              }
            />
          </Col>
        </Row> */}
      </>
    ),
    [PRODUCT_GROUPS.TEAM_MERCHANDISE]: (
      <>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Sport"
              placeholder="No sport selected. Type to search..."
              defaultOptions={sportDefaultOptions}
              loadOptions={sportFetchOptions}
              isLoading={sportLoading}
              value={sportGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("sport_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.sport_id && formik.errors.sport_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.sport_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Product"
              placeholder="No product selected. Type to search..."
              defaultOptions={productDefaultOptions}
              loadOptions={productFetchOptions}
              isLoading={productLoading}
              value={productGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("product_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.product_id && formik.errors.product_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.product_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Team"
              placeholder="No team selected. Type to search..."
              defaultOptions={teamDefaultOptions}
              loadOptions={teamFetchOptions}
              isLoading={teamLoading}
              value={teamGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("team_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.team_id && formik.errors.team_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.team_id?.join(" "))
              }
            />
          </Col>
        </Row>
      </>
    ),
    [PRODUCT_GROUPS.MATCH_BALLS]: (
      <>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Sport"
              placeholder="No sport selected. Type to search..."
              defaultOptions={sportDefaultOptions}
              loadOptions={sportFetchOptions}
              isLoading={sportLoading}
              value={sportGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("sport_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.sport_id && formik.errors.sport_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.sport_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Product"
              placeholder="No product selected. Type to search..."
              defaultOptions={productDefaultOptions}
              loadOptions={productFetchOptions}
              isLoading={productLoading}
              value={productGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("product_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.product_id && formik.errors.product_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.product_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Competition"
              placeholder="No competition selected. Type to search..."
              defaultOptions={competitionDefaultOptions}
              loadOptions={competitionFetchOptions}
              isLoading={competitionLoading}
              value={competitionGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("competition_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.competition_id &&
                  formik.errors.competition_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.competition_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Term"
              placeholder="No term selected. Type to search..."
              defaultOptions={termDefaultOptions}
              loadOptions={termFetchOptions}
              isLoading={termLoading}
              value={termGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("term_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.term_id && formik.errors.term_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.term_id?.join(" "))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <AsyncDropdown
              label="Edition"
              placeholder="No edition selected. Type to search..."
              defaultOptions={editionDefaultOptions}
              loadOptions={editionFetchOptions}
              isLoading={editionLoading}
              value={editionGetSelectedOption()}
              onChange={(selected) => {
                formik.setFieldValue("edition_id", selected?.value || null);
              }}
              errorText={
                (formik.touched.edition_id && formik.errors.edition_id) ||
                (saveError?.status === 422 &&
                  saveError?.response?.data?.errors?.edition_id?.join(" "))
              }
            />
          </Col>
        </Row>
      </>
    ),
  };

  return fields[productGroup] || fields[PRODUCT_GROUPS.JERSEYS];
};

export default FormFields;
